<template>
    <div class="lmy-doc-detail">
        <div class="doc-title">龙猫游个人信息保护政策</div>
        <div class="doc-date">
          发布日期：2022年01月01日<br>生效时间：2022年03月01日
        </div>
        <div class="doc-content">
          <div class="doc-title">引言</div>
          <div class="indent">
            欢迎您访问龙猫游！龙猫游（以下也称“我们”）深知个人信息对您的重要性，因此我们非常重视保护您的隐私和个人信息。我们将按照法律法规要求并通过《龙猫游个人信息保护政策》（以下简称“本政策”）向您说明我们在您使用龙猫游平台的产品/服务时如何处理您的个人信息，以及我们为您提供的访问、更新、删除和保护这些信息的方式。
          </div>
          <div class="text-bold">【特别提示】在您使用龙猫游平台的产品/服务之前，请您务必仔细阅读、充分理解本政策，特别是以字体加粗的条款，您应当重点阅读，在确认充分理解并同意后开始使用龙猫游平台的产品/服务。如果您或您的监护人（如果您是未成年人）不同意本政策的任何内容，您可以使用龙猫游平台的搜索、浏览功能，但您将无法使用龙猫游平台的产品/服务。如对本政策内容有任何疑问、意见或建议，您可通过本政策第九条提供的联系方式与我们联系。<br><br>
          请您特别注意本政策的适用范围：<br>
          1、本政策适用于龙猫游平台提供的所有产品和服务。如我们及关联公司的产品/服务中使用了龙猫游平台提供的产品/服务但未设独立个人信息保护政策的，则该部分产品/服务同样适用于本政策。如我们及关联公司的产品/服务已设独立个人信息保护政策的，则独立的个人信息保护政策优先适用，该等独立的个人信息保护政策中未提及而本政策有约定的内容，适用本政策。<br>
          2、本政策不适用于龙猫游平台的产品/服务中包含的或链接至第三方提供的信息/服务（包括任何第三方应用、网站等），该等信息/服务由第三方负责运营，须遵循该第三方的个人信息保护政策或类似规定。
          </div>
          <div class="doc-title">第一部分 定义</div>
          <div>
            1、龙猫游平台：“龙猫游平台”包括但不限于App、微信公众号、微信小程序、百度小程序、支付宝小程序或H5页面等，客户端适用的终端设备包括但不限于PC、平板电脑、手机、电视等<br>
            2、龙猫游/我们：包括龙猫游平台的开发者和运营者深圳市前海乐订会展服务有限公司（注册地址为深圳市前海深港合作区前湾一路1号A栋201室）及关联公司在内的企业集团。<br>
            3、关联公司：指深圳市龙腾捷旅信息科技股份有限公司（CN Travel Group）旗下所有公司及其附属、关联公司，包括但不限于、深圳市港捷旅国际旅行社有限公司等。<br>
            4、用户/您：访问或使用龙猫游平台所提供的产品/服务的自然人，包括注册用户及未注册用户。<br>
            5、个人信息：以电子或者其他方式记录的与已识别或者可识别的自然人有关的各种信息。<br>
            6、敏感个人信息：一旦泄露、非法提供或滥用可能危害人身和财产安全，极易导致个人名誉、身心健康受到损害或歧视性待遇等的个人信息。本政策中涉及的敏感个人信息包括<label class="text-bold">生物识别、宗教信仰、特定身份、医疗健康、金融账户、行踪轨迹</label>等信息，以及不满十四周岁<label class="text-bold">未成年人的个人信息</label>。<br>
            7、个人信息删除：在实现日常业务功能所涉及的系统中去除个人信息的行为，使其保持不可被检索、访问的状态。<br>
            8、儿童：不满十四周岁的未成年人。<br>
            9、未成年人：不满十八周岁的自然人为未成年人。十六周岁以上的未成年人，以自己的劳动收入为主要生活来源的，视为完全民事行为能力人。
          </div>
          <div class="doc-title">第二部分 个人信息保护政策</div>
          <div>
            本政策将帮助您了解以下内容：<br>
            一、我们如何收集和使用您的个人信息<br>
            二、我们如何使用Cookie和同类技术<br>
            三、我们如何共享、转移、委托处理和公开披露您的个人信息<br>
            四、我们如何存储和跨境传输您的个人信息<br>
            五、我们如何保护您的个人信息安全<br>
            六、我们如何保护未成年人的个人信息<br>
            七、您如何行使您的个人信息权利<br>
            八、本政策的修订和通知<br>
            九、如何联系我们<br>
            附件：《龙猫游账户注销协议》<br><br>
            <div class="text-bold text-gap">一、我们如何收集和使用您的个人信息</div>
            在您使用我们的产品/服务时，您需要/可以选择授权我们收集和使用个人信息的情形包括：<br>
            1、为了向您提供我们产品/服务的基本功能，您需要授权我们收集、使用必要信息的情形。如您拒绝提供前述必要信息，您将无法正常使用我们的产品/服务；<br>
            2、为了向您提供我们产品/服务的附加功能，您可以选择授权我们收集、使用信息的情形。如您拒绝提供前述信息，您将无法正常使用相关附加功能或无法实现我们拟达到的功能效果，但并不会影响您正常使用我们产品/服务的基本功能。
            <div class="text-bold">请您注意，因我们向您提供的产品和服务种类众多，我们将根据您选择使用的具体产品/服务范围，遵循“合理、正当、必要”原则收集和使用您的个人信息。除此之外，您理解并同意，基于向您提供更好的产品和服务的目的，我们可能会不时推出新的或优化后的功能，可能增加或变更收集和使用个人信息的目的、范围和方式。对此，我们将通过更新本政策、弹窗或站内信等通知方式另行向您说明收集和使用对应信息的目的、范围和方式，并为您提供同意与否的选项，且在征得您的明示同意后收集、使用对应信息。在此过程中，如您有任何疑问、意见或建议，您可通过本政策第九条提供的联系方式与我们联系。</div>
            <div class="text-bold">（一）为您提供搜索、浏览功能</div>
            通常情况下，您可以在同意隐私政策后且未登录状态或隐私浏览模式下在龙猫游平台上搜索和浏览各类产品。但请您理解，出于保护商业信息目的，酒店页面上的部分详细信息可能需要您注册账户并登录后才可以进行浏览。<br>
            在您同意本政策后，为保障搜索、浏览功能的实现，我们会收集您在网页或APP输入的搜索关键字、您点击的页面或链接以便在龙猫游平台的服务端向您返回相应的页面或结果。此外，我们也会收集您的日志信息。<br>
            请您注意，单独的日志信息或仅搜索关键词信息无法单独识别您的身份，不属于您的个人信息，只有当您的单独的日志信息或搜索关键词信息与您的其他信息相互结合使用并可以识别您的身份时；则在结合使用期间，我们会将您的日志信息或搜索关键词信息作为您的个人信息，按照本政策对其进行处理与保护。
            <div class="text-bold">（二）帮助您注册与管理龙猫游账户</div>
            1、账户注册<br>
            若您想使用龙猫游平台的产品/服务，您首先需要注册一个龙猫游账户成为龙猫游平台的会员。注册时，您至少需提供手机号（用于接收短信验证码）并设置密码用以创建龙猫游账户。如您拒绝提供手机号，您将无法在龙猫游平台创建账户并使用龙猫游平台的产品/服务，但不影响您正常使用龙猫游平台的搜索、浏览功能。
            <div class="text-bold">您理解并同意，您使用龙猫游账户登录后在龙猫游平台的一切行为均代表您本人。您的龙猫游账户操作所产生的电子信息记录均为您行为的有效凭据，并由您本人承担由此产生的全部责任。</div>
            2、账户登录<br>
            若您选择通过第三方账户（包括微信、QQ、Apple、支付宝、微博、百度等）登录龙猫游平台，在您同意本政策后，我们将从第三方获取您授权共享的第三方账户信息（头像、昵称及您在页面授权的其他个人信息），并将您的第三方账户与您的龙猫游账户绑定，使您可以通过第三方账户直接登录并使用我们的服务。 我们会依据与第三方的约定，在符合相关法规的前提下，使用您的个人信息。
            <br>请您注意，在您首次使用第三方账户登录龙猫游平台（包括解绑第三方账户后的首次登录）的情形下，为确保符合法律法规的要求，保护您的账户安全，我们仍会要求您提供手机号，以验证您的真实身份。同时，我们会根据您提供的手机号实现第三方账户与龙猫游账户的绑定。
            <div class="text-bold">（三）为您提供产品/服务信息的展示、推荐与推送</div>
            1、个性化展示与推荐<br>
            在您使用龙猫游平台的产品/服务过程中，我们会收集和使用您在访问或使用我们网站和客户端时的浏览记录、搜索记录、<label class="text-bold">地理位置</label>、设备信息（包括设备制造商、屏幕宽高、设备类型、设备识别符），以及其他取得您授权的信息，进行综合统计、以便了解您的喜好特征，从而向您推荐更契合您需求的个性化产品/服务，提升您的用户体验。<br>
            此外，我们可能会基于您的喜好结果与第三方广告平台合作（如今日头条、百度、广点通等）向您推荐个性化产品/服务。广告平台仅向我们提供了展示产品/服务的窗口，窗口内容是龙猫游平台内的个性化产品/服务展示信息，因此我们不会向广告平台或广告商提供您的任何个人信息。
            <div class="text-bold">（四）为您提供收藏、关注与分享功能</div>
            在您使用龙猫游平台的产品/服务过程中，您可以选择对感兴趣的产品/服务进行收藏、与您感兴趣的商家/品牌/其他会员建立关注关系，也可以通过龙猫游平台的功能组件向第三方进行信息分享，我们至少需要收集您在收藏、关注与分享过程中产生的日志信息，用于实现上述功能以及其他我们明确告知的目的。
            <div class="text-bold">（五）为您提供下单与订单管理功能</div>
            当您准备订购龙猫游平台的产品/服务时，龙猫游平台系统会自动生成您订购该产品/服务的订单。在下单和订单管理过程中，我们可能会收集如下信息：<br>
            （1）您所选择的不同产品/服务所要求提供的信息；<br>
            （2）您的联系人姓名、手机号；<br>
            （3）您在使用龙猫游平台的产品/服务过程中产生的订单信息。<br>
            我们收集这些信息是为了帮助您确定交易、支付结算、获得通知、帮助您查询和管理订单信息，以及提供客服与售后服务；我们还会使用您的订单信息来判断您的交易是否存在异常，以保护您的交易安全。<br>
            因旅行产品/服务的特殊性，您所选择的以下产品/服务，需要您进一步提交必要的信息才能完成预订，这些信息您需要自行填写，或者授权我们以其他方式帮助您完成信息录入，我们同时也提请您在具体预订过程中予以关注：<br>
            （1）当您预订酒店、民宿和客栈时，您至少需要提供入住人姓名、手机号信息；视产品不同可能还需要您提供证件类型和<label class="text-bold">证件号</label>、邮箱信息。<br>
            （2）当您预订景点门票、活动服务时，您至少需要提供出行人的姓名以及联系手机号，视产品不同可能还需要您提供联系人的邮箱、出行人的手机号、证件类型和<label class="text-bold">证件号</label>信息、证件有效期、签发地、国家/地区、国籍、性别、出生日期、出生地（省份）、体重和身高（骑马类项目）、鞋码和近视度数（安全考虑）。<br>
            （3）当您预订旅游服务时，旅游服务（跟团游、自由行、周末游、邮轮游、周边游、定制游、高端游、主题旅行、机票/火车票+酒店、酒店+景点）作为组合产品，需要您提供的信息取决于具体产品的子服务（机票、火车票、租车、专车、酒店、民宿、客栈、汽车票、旅游专线、船票、游艇帆船、游船、签证、向导、门票、活动、保险）所收集的信息的组合，且具体服务收集的信息类别不会超过其涉及的子服务收集的信息类别的总和（如服务A收集信息x，服务B收集y，组合服务AB收集的信息不会超过x+y）。<br>
            （4）当您的出行人中包含未成年人时，我们需要您作为监护人或在取得监护人的同意下提供出行的<label class="text-bold">未成年人的姓名、证件类型、证件号</label>。其他需要您进一步提供必要信息才能完成产品/服务的预订的，具体以预订流程中的展示、提示或授权内容为准，请注意仔细阅读。
            <div class="text-bold">（六）帮助向您完成产品/服务的交付</div>
            为向您完成产品/服务的交付，我们在此过程中至少需要收集和使用您的订单信息以保证您的订购的产品/服务能够安全完成交付。<br>
            若您订购或参与抽奖等营销推广活动获得的产品/服务需要使用电子兑换或邮寄（发票、商品）服务的，您至少需要提供产品/服务的使用人或收件人的姓名、手机号，视产品不同可能还需要您提供配送地址、电子邮箱地址，以便您的发票、产品/服务能够兑换或送达。<br>
            若您就订购的产品/服务需要开具纸质或电子发票的，我们至少需要收集发票抬头、邮箱在内的开票信息以及上述配送信息。
            <div class="text-bold">（七）为您提供客户服务与处理争议</div>
            为保证您的账户安全，我们的电话客服和在线客服会使用您的会员资料和订单信息，以验证您的身份。当您主动要求我们提供与您订单相关的客户服务时，我们可能会查询您的相关订单信息以便给予您适当的帮助和处理。如您主动要求客服协助您修改有关信息（如配送地址、联系人或联系电话），您可能还需要提供上述信息外的其他信息以便完成修改。<br>
            当您与我们联系时，我们可能会保存与您的<label class="text-bold">通信/通话记录和内容</label>，或您留下的联系方式及相关信息，以便与您联系或帮助您解决问题，或记录相关问题的处理方案及结果。上述录音在被保留法律规定的最短必要时间后会自动删除，除非由于合规要求或合法利益需要而保留。
            <div class="text-bold">（八）为您调用权限提供其他附加服务</div>
            为向您提供个性化的产品/服务，提升用户体验，您可以基于您自主授权的移动设备操作系统的相关权限来使用我们的附加功能，如果您不开启这些权限或不提供这些权限收集的个人信息，您依然可以完成龙猫游平台上各类服务的预订和相关服务。请您注意这些权限可能因移动设备操作系统的不同而存在差异。
            <div class="text-bold">请您注意，您开启任意权限即代表您授权我们可以收集和使用相关个人信息来为您提供对应服务，您一旦关闭任意权限即代表您取消了授权，我们将不再基于对应权限继续收集和使用相关个人信息，也无法为您提供该权限所对应的服务。但是，您关闭权限的决定不会影响此前基于您的授权所进行的信息收集及使用。</div>
            您可通过访问龙猫游终端设备权限列表查询龙猫游平台可能申请与使用的相关权限。</div>
            <div class="text-bold text-gap">安卓系统应用权限列表</div>
            <div class="text-gap">
              <label class="text-bold">权限名称：</label>    读取手机/电话状态<br>
              <label class="text-bold">权限功能说明：</label>    获取IMEI和IMSI等设备识别信息以及本机号码<br>
              <label class="text-bold">使用场景或目的：</label>    为实现信息推送，保障账户和交易安全、排障及广告功能；预订火车票时向12306提供基于该权限获取的信息以避免预订失败<br>
            </div>
            <div class="text-gap">
              <label class="text-bold">权限名称：</label>    位置<br>
              <label class="text-bold">权限功能说明：</label>    通过网络或者卫星对您的设备定位<br>
              <label class="text-bold">使用场景或目的：</label>    自动为您选择您所在的城市从而节省您手工输入所在地的信息，自动为您推荐附近包括酒店、景点在内的相关旅行服务，自动计算包括使用用车服务时附近的车辆信息、您与司机的距离、您的行驶路线在内的信息来实现便捷的预定或提升您的人身安全， 以及基于您所在景区的位置为您提供所在景区的语音导览功能（用户使用该功能时APP需要持续获取定位来播放附近景点的讲解），在金融服务中用于查看和获取当前所在区域的服务以及对风险情况进行评估<br>
            </div>
            <div class="text-gap">
              <label class="text-bold">权限名称：</label>    存储<br>
              <label class="text-bold">权限功能说明：</label>    读取和写入设备内存和SD卡<br>
              <label class="text-bold">使用场景或目的：</label>    更改头像、发送社区动态、保存图片到本地等<br>
            </div>
            <div class="text-gap">
              <label class="text-bold">权限名称：</label>    相机<br>
              <label class="text-bold">权限功能说明：</label>    拍摄照片和录制视频<br>
              <label class="text-bold">使用场景或目的：</label>    用于完成视频拍摄、拍照、旅拍（社区）、证件扫描、二维码扫描、直播及人脸识别认证功能<br>
            </div>
            <div class="text-gap">
              <label class="text-bold">权限名称：</label>    麦克风<br>
              <label class="text-bold">权限功能说明：</label>    录制音频<br>
              <label class="text-bold">使用场景或目的：</label>    用于完成客服语音咨询功能<br>
            </div>
            <div class="text-gap">
              <label class="text-bold">权限名称：</label>    读取通讯录<br>
              <label class="text-bold">权限功能说明：</label>    获取通讯录信息<br>
              <label class="text-bold">使用场景或目的：</label>    用于在订单填写页面快速选择您通讯录中的联系人<br>
            </div>
            <div class="text-gap">
              <label class="text-bold">权限名称：</label>    读写日历<br>
              <label class="text-bold">权限功能说明：</label>    获取或修改已设置的日历信息<br>
              <label class="text-bold">使用场景或目的：</label>    用于开启出行前的日历提醒，此外在您使用火车票定时抢票功能时，我们需要读取日历权限来确保在有多个同一时间点的定时抢票提醒的场景下不会重复写入日历中<br>
            </div>
            <div class="text-gap">
              <label class="text-bold">权限名称：</label>    拨打电话<br>
              <label class="text-bold">权限功能说明：</label>    调用系统拨打电话权限<br>
              <label class="text-bold">使用场景或目的：</label>    用于在APP内直接拨打电话，方便联系客服<br>
            </div>
            <div class="text-gap">
              <label class="text-bold">权限名称：</label>    蓝牙<br>
              <label class="text-bold">权限功能说明：</label>    获取蓝牙名<br>
              <label class="text-bold">使用场景或目的：</label>    用于预订火车票时向12306提供基于该权限获取的信息以避免预订失败<br>
            </div>
            <div class="text-gap">
              <label class="text-bold">权限名称：</label>    NFC<br>
              <label class="text-bold">权限功能说明：</label>    实现NFC支付<br>
              <label class="text-bold">使用场景或目的：</label>    用于在支持NFC功能的手机上开启该功能来实现NFC支付<br>
            </div>
            <div class="text-gap">
              <label class="text-bold">权限名称：</label>    读取应用列表<br>
              <label class="text-bold">权限功能说明：</label>    读取手机中已安装的应用信息<br>
              <label class="text-bold">使用场景或目的：</label>    下单支付环节和金融产品风险控制<br>
            </div>
            <div class="text-gap">
              <label class="text-bold">权限名称：</label>    悬浮窗<br>
              <label class="text-bold">权限功能说明：</label>    悬浮在其他APP之上<br>
              <label class="text-bold">使用场景或目的：</label>    退出APP后悬浮播放直播视频<br>
            </div>
            <div class="text-gap">
              <label class="text-bold">权限名称：</label>    获取魅族手机账户<br>
              <label class="text-bold">权限功能说明：</label>    基于魅族SDK获取手机账户的登录<br>
              <label class="text-bold">使用场景或目的：</label>    用于魅族手机用户获取手机账户实现应用登录<br>
            </div>
            <div class="text-bold text-gap">iOS系统应用权限列表</div>
            <div class="text-gap">
              <label class="text-bold">权限名称：</label>    网络<br>
              <label class="text-bold">权限功能说明：</label>    实现和服务端的网络连接<br>
              <label class="text-bold">使用场景或目的：</label>    APP网络连接的必要权限，确保龙猫游旅行APP能够连接龙猫游服务端<br>
            </div>
            <div class="text-gap">
              <label class="text-bold">权限名称：</label>    通知<br>
              <label class="text-bold">权限功能说明：</label>    接收通知<br>
              <label class="text-bold">使用场景或目的：</label>    用于接收龙猫游旅行APP发送的通知<br>
            </div>
            <div class="text-gap">
              <label class="text-bold">权限名称：</label>    位置<br>
              <label class="text-bold">权限功能说明：</label>    通过网络或者卫星对您的设备定位<br>
              <label class="text-bold">使用场景或目的：</label>    自动为您选择您所在的城市从而节省您手工输入所在地的信息，自动为您推荐附近包括酒店、景点在内的相关旅行服务，自动计算包括使用用车服务时附近的车辆信息、您与司机的距离、您的行驶路线在内的信息来实现便捷的预定或提升您的人身安全， 以及基于您所在景区的位置为您提供所在景区的语音导览功能（用户使用该功能时APP需要持续获取定位来播放附近景点的讲解），在金融服务中用于查看和获取当前所在区域的服务以及对风险情况进行评估<br>
            </div>
            <div class="text-gap">
              <label class="text-bold">权限名称：</label>    相册<br>
              <label class="text-bold">权限功能说明：</label>    读取和写入设备相册中的内容<br>
              <label class="text-bold">使用场景或目的：</label>    用于上传您的照片、视频等来进行各类旅行订单的点评等信息发布功能<br>
            </div>
            <div class="text-gap">
              <label class="text-bold">权限名称：</label>    相机<br>
              <label class="text-bold">权限功能说明：</label>    拍摄照片和录制视频<br>
              <label class="text-bold">使用场景或目的：</label>    用于完成视频拍摄、拍照、社区发布、证件扫描、二维码扫描、直播及人脸识别认证功能<br>
            </div>
            <div class="text-gap">
              <label class="text-bold">权限名称：</label>    麦克风<br>
              <label class="text-bold">权限功能说明：</label>    录制音频<br>
              <label class="text-bold">使用场景或目的：</label>    用于完成客服语音咨询功能<br>
            </div>
            <div class="text-gap">
              <label class="text-bold">权限名称：</label>    日历<br>
              <label class="text-bold">权限功能说明：</label>    获取或修改已设置的日历信息<br>
              <label class="text-bold">使用场景或目的：</label>    用于开启出行前的日历提醒，此外在您使用火车票定时抢票功能时，我们需要读取日历权限来确保在有多个同一时间点的定时抢票提醒的场景下不会重复写入日历中<br>
            </div>
            <div class="text-gap">
              <label class="text-bold">权限名称：</label>    面部ID<br>
              <label class="text-bold">权限功能说明：</label>    使用面部ID<br>
              <label class="text-bold">使用场景或目的：</label>    在支持面部识别的IOS设备上实现基于面部ID的认证功能<br>
            </div>
            <div class="text-gap">
              <label class="text-bold">权限名称：</label>    触控ID<br>
              <label class="text-bold">权限功能说明：</label>    使用触控ID<br>
              <label class="text-bold">使用场景或目的：</label>    在支持触控ID的IOS设备上实现基于触控ID的认证功能<br>
            </div>
            <div class="text-gap">
              <label class="text-bold">权限名称：</label>    语音转文字<br>
              <label class="text-bold">权限功能说明：</label>    将语音转化为文字<br>
              <label class="text-bold">使用场景或目的：</label>    用于在支持语音转文字的场景实现将语音转为文字后实现文字输入功能<br>
            </div>
            <div class="text-gap">
              <label class="text-bold">权限名称：</label>    广告识别符<br>
              <label class="text-bold">权限功能说明：</label>    获取广告识别符<br>
              <label class="text-bold">使用场景或目的：</label>    获取IDFA、IDFV，用于广告推荐<br>
            </div>
            <div class="text-gap">
              <label class="text-bold">权限名称：</label>    运动与健身<br>
              <label class="text-bold">权限功能说明：</label>    获取手机转角、方向数据<br>
              <label class="text-bold">使用场景或目的：</label>    用于VR图片浏览<br>
            </div>
            <div>
              <div class="text-bold">（九）改进龙猫游平台的产品/服务</div>
              1、我们可能会对收集的信息进行去标识化地研究、统计分析和预测，用于改善龙猫游平台的内容和布局，为商业决策提供产品或服务支撑，以及改进我们的产品和服务。<br>
              2、我们可能将您的订单数据用于数据分析，以便让我们能够了解您所在的位置、喜好和人口统计信息，或与其他来源（包括第三方）的数据相匹配，从而开发和改进我们的产品和服务。<br>
              3、我们可能会通过您提供的联系方式邀请您参与市场调查，并基于您参加市场调查所提供的信息，分析、衡量您对我们的产品、服务和网站的兴趣，从而开发和改进我们的产品和服务。如您选择不参与市场调查并提供有关信息（以具体市场调查展示页面为准），不会影响您使用龙猫游平台的基本功能。
              <div class="text-bold">（十）收集和使用您的个人信息的特别说明</div>
              1、若您提供的信息中含有其他用户的个人信息，例如，您通过龙猫游平台为他人订购产品/服务时需要提交实际订购人的个人信息，或您通过龙猫游平台主动上传、发布或共享的信息中涉及其他用户的个人信息的，在前述情形下，在向龙猫游平台提供这些个人信息之前，您须确保您已经取得本人的同意，并确保其已知晓并接受本政策。若其中涉及儿童个人信息的，您需要事先取得对应儿童监护人的同意。除非符合征得授权同意的例外情形（见本政策“一、我们如何收集和使用您的个人信息”），否则我们将会按照法律法规及国家标准的要求，针对某些场景下的敏感个人信息的处理，通过合理的方式征得您的单独同意。具体单独同意方式，以具体的功能页面显示为准。<br>
              2、若我们将信息用于本政策未载明的其他用途，或者将基于特定目的收集而来的信息用于其他目的，均会重新获得您的授权同意。<br>
              3、我们可能从为您提供服务的关联公司、业务合作伙伴等第三方处获得其所收集的您的相关信息。例如，您通过我们关联公司、业务合作伙伴网站及其移动应用软件等预订时，您向其提供的预订信息可能会转交给我们，以便我们处理您的订单，确保您顺利预订。我们将依据与第三方的约定，在收集前要求第三方说明您的个人信息来源，并对这些个人信息来源的合法合规性进行确认，了解第三方所收集您的个人信息的授权同意范围。如果我们收集和使用您的信息的目的，超出了第三方已获得的授权范围，我们会自行或要求该第三方另行征得您的同意后再处理您的个人信息。<br>
              4、征得授权同意的例外<br>
              您充分知晓，根据法律法规要求，以下情形中我们收集、使用您的个人信息无需征得您的授权同意：<br>
              l 为履行龙猫游法定职责或者法定义务所必需；<br>
              l 与国家安全、国防安全有关的；<br>
              l 与公共安全、公共卫生、重大公共利益有关的；<br>
              l 与犯罪侦查、起诉、审判和判决执行等有关的；<br>
              l 为订立、履行您作为一方当事人的合同所必需；<br>
              l 在紧急状况下，出于维护您或其他个人的生命健康和财产安全；<br>
              l 所收集的个人信息是个人信息主体自行向社会公众公开的或其他已经合法公开的个人信息；<br>
              l 从合法公开披露的信息中收集的您的个人信息的，如合法的新闻报道、政府信息公开等渠道；<br>l 为公共利益实施新闻报道、舆论监督等行为，在合理的范围内处理个人信息；用于维护所提供的产品或服务的安全稳定运行所必需的，例如发现、处置产品或服务的故障；<br>
              l 学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；<br>
              l 法律法规以及国家标准规定的其他情形。<br>
              请知悉，根据适用的法律，若我们对个人信息采取技术措施和其他必要措施进行处理，使得数据接收方无法重新识别特定个人且不能复原，则此类处理后数据的使用无需另行向您通知并征得您的同意。
              <div class="text-bold text-gap">二、我们如何使用Cookie和同类技术</div>
              <div class="text-bold">（一）Cookie</div>
              为了让您获得更轻松便捷的访问体验，您访问龙猫游平台或使用我们提供的服务时，我们可能会在您的设备终端或系统上存储名为 Cookie的小型数据文件用来识别您的身份，这样可以帮您省去重复输入注册信息的步骤，帮您优化对广告的选择与互动及其帮助判断您的账户安全状态。您可以清除计算机或移动设备上保存的所有 Cookie，您有权接受或拒绝Cookie，如果浏览器自动接受Cookie，您可以根据自己的需要修改浏览器的设置以拒绝Cookie。请注意，如果您选择拒绝Cookie，那么您可能无法更好地体验我们提供的服务。
              <div class="text-bold">（二）其他同类技术</div>
              除 Cookie 外，为监测广告投放效果，我们还会在网站上使用像素标签技术，借助于像素标签，我们可以更好地了解我们投放的广告是否被用户浏览。
              <div class="text-bold text-gap">三、我们如何共享、转移、委托处理和公开披露您的个人信息</div>
              <div class="text-bold">（一）共享与提供</div>
              1、处理原则<br>
              我们可能会向合作伙伴等第三方共享您的订单信息、账户信息、设备信息以及位置信息，以保障为您提供的服务顺利完成。但我们仅会出于合法、正当、必要、特定、诚信、明确的目的共享您的个人信息，并且只会共享提供服务所必要的个人信息。我们将评估第三方收集您的个人信息的合法性、正当性、必要性，同时，要求第三方在您的授权同意范围内处理您的个人信息，采取必要的信息管理措施与技术手段，防止您的个人信息发生泄露、损毁、丢失、篡改等后果。第三方无权将所共享的您的个人信息用于任何其他用途，如要改变个人信息的处理目的、处理方式的，将重新您的授权同意。<br>
              2、单独同意<br>
              除非符合征得授权同意的例外情形（见本政策“一、我们如何收集和使用您的个人信息”），否则我们将会按照法律法规及国家标准的要求，针对除前述情形之外的某些场景下的个人信息的共享与提供，采取合理的方式另外征得您的单独同意。但不论是否需要征得您的单独同意，我们均会以合理的方式向您明示告知具体向您提供所涉产品/服务的第三方供应商信息及其处理您个人信息的目的、方式和种类，例如，在您准备订购部分龙猫游平台的产品/服务时，我们可能会在您下单前通过订单填写页面或订单确认页面向您明示告知上述信息，并在必要时征得您授权龙猫游向供应商或服务商提供您的个人信息的单独同意。具体的单独同意形式，请以具体产品/服务订单页面为准。<br>
              3、我们的合作伙伴包括以下类型（包含中国境内和中国境外实体）：<br>
              （1）供应商：包括但不限于为了满足您预订需求的酒店、航空公司、邮轮、汽车租赁、旅行社、景区和活动提供商和代理商，我们将向供应商共享个人基本资料、个人身份信息、联系人信息。这些供应商可能根据需要与您联系，以完成旅行产品或服务。<br>
              （2）金融机构和第三方支付机构：当您预订订单、申请退款、购买保险时，我们会与金融机构或第三方支付机构共享特定的订单信息，当我们认为用于欺诈检测和预防目的实属必要时，我们将进一步和相关金融机构共享其他必要信息，如IP地址等。您在使用此类服务前，我们将会通过页面提示、交互流程、协议在线展示等方式另行向您说明相应的个人信息共享规则，并征得您的同意。<br>
              （3）业务合作伙伴：我们可能与合作伙伴一起为您提供产品或者服务，将向合作伙伴共享相关个人信息，用于包括快递业务、通讯服务、客户服务、市场推广、广告投放、技术服务、实名认证服务、咨询服务。例如，为向您提供服务信息或商业信息推送之目的，我们会向短信服务商提供您的手机号及拟推送的信息内容。当然，您可以通过“七、您如何行使您的个人信息权利”中“（六）限制自动化决策”，设置关闭商业信息推送功能，功能关闭后我们将不再向您推送针对您个人特征的商业信息。<br>
              （4）关联公司：我们可能会与我们的关联公司共享您的相关个人信息，使我们能够向您提供与旅行相关的或者其他产品或服务，他们会采取不低于本政策同等严格的保护措施。<br>
              请您注意，基于业务合作伙伴和关联公司防范和检测欺诈的目的，我们可能也会审慎地提供您的必要个人信息，这些个人信息的提供会经过严格的内部安全评估和审批并通过签署相应的协议限定这些信息的使用目的。<br>
              4、龙猫游的关联公司允许龙猫游平台的用户使用龙猫游账户登录关联公司的平台并使用其服务，龙猫游平台的用户在关联公司的任何行为均需遵守相应协议的约定、公布的规则以及有关正确使用服务的说明和操作指引。
              <div class="text-bold">（二）第三方SDK</div>
              为了您能够接收信息推送、在第三方平台登录及分享信息、使用第三方支付、使用地图服务、使用人脸识别认证功能、实现手机号一键登录等服务及功能，我们的应用中会嵌入授权合作伙伴的软件工具开发包（以下简称“SDK”）或类似其他应用程序，我们通过操作系统提供接口调用的方式使用这些SDK。<br>
              我们会对授权合作伙伴的SDK进行严格的安全技术检测和准入控制。我们的合作伙伴无权将所共享的您的个人信息用于任何其他用途，如要改变个人信息的处理目的，则其应再次征求您的授权同意。
              <div class="text-bold">（三）信息转移</div>
              我们不会将您的个人信息转移给任何公司、组织和个人，但以下情况除外：<br>
              （1）事先获得您的明确同意或授权；<br>
              （2）根据适用的法律法规、法律程序的要求、强制性的行政或司法要求；<br>
              （3）在涉及合并、分立、收购、资产转让或类似的交易时，如涉及到个人信息转移，我们会在正式进行信息转移前，向您告知接收信息公司、组织的名称和联系方式，并要求新的持有您个人信息的公司、组织继续受本政策的约束，继续履行原先由我们承担的个人信息处理义务。否则,我们将要求该公司、组织重新向您征求授权同意。
              <div class="text-bold">（四）委托处理</div>
              为了提升信息处理效率，降低信息处理成本或提高信息处理准确性，我们可能会委托有专业技术能力的关联公司或龙猫游以外的外部服务供应商处理您的个人信息。我们会与受托方签署委托处理协议，并要求受托方按照委托处理协议、本政策以及其他任何相关的保密和安全措施来处理个人信息。委托关系不生效、无效或被撤销或者终止时，我们会要求受托方返还、删除您的个人信息(包括但不限于因委托处理获取到的原始信息或副本、摘要等)，不得保留。未经您的授权同意，我们禁止受托方转委托他人处理您的个人信息。
              <div class="text-bold">（五）公开披露</div>
              我们仅会在以下情形，公开披露您的个人信息：<br>
              （1）根据您的需求，在您单独同意的前提下，根据您认可的披露方式下披露您所指定的个人信息；<br>
              （2）根据法律、法规的要求、强制性的行政执法或司法要求所必须提供您个人信息的情况下，我们可能会依据所要求的个人信息类型和披露方式披露您的个人信息。在符合法律法规的前提下，当我们收到上述披露信息的请求时，我们会要求必须出具与之相应的法律文件，如传票或调查函。
              <div class="text-bold text-gap">四、我们如何存储您的个人信息</div>
              <div class="text-bold">（一）存储地点</div>
              1、处理原则<br>
              我们会按照法律法规规定，将中华人民共和国境内收集的用户个人信息存储于中国境内。
              <div class="text-bold">（二）存储期限</div>
              我们仅在本政策所述目的所必需且最短的期间内，或法律法规要求的时限内保留您的信息。例如，当您使用龙猫游平台的注册功能时，我们需要收集您的手机号，且在您提供后并在您使用该功能期间，我们需要持续为您保留您的手机号，以向您正常提供该功能、保障您的账户和系统安全。在超出上述存储期限后，或在您行使个人信息删除权、注销账户的情况下，我们会对您的个人信息进行删除或匿名化处理。<br>
              但在下列情况下，我们有可能因需符合法律要求，调整个人信息的存储时间：<br>
              （1）为遵守适用的法律法规等有关规定（例如：《电子商务法》规定：商品和服务信息、交易信息保存时间自交易完成之日起不少于三年）；<br>
              （2）为遵守法院判决、裁定或其他法律程序的规定；<br>
              （3）为遵守相关政府机关或法定授权组织的要求；<br>
              （4）为维护社会公共利益，为保护龙猫游平台的用户、我们或我们的关联公司、其他用户或雇员的人身财产安全或其他合法权益所合理必需的用途。
              <div class="text-bold">（三）停止运营</div>
              如我们停止运营龙猫游平台产品或服务，我们将及时停止继续收集您个人信息的活动，将停止运营的通知以逐一送达或公告的形式通知您，对所持有的个人信息进行删除或匿名化处理。
              <div class="text-bold text-gap">五、我们如何保护您的个人信息安全</div>
              1、龙猫游非常重视信息安全，成立了专门的负责团队，负责对个人信息处理活动以及采取的保护措施进行监督。 我们努力为您提供信息保护，采取了合适的管理、技术以及物理安全措施，参照国内外信息安全标准及最佳实践建立了与业务发展相适应的信息安全保障体系。<br>
              2、我们从数据的生命周期角度出发，在数据收集、存储、显示、处理、使用、销毁等各个环节建立了安全防护措施，根据信息敏感程度的级别采取不同的控制措施，包括但不限于访问控制、SSL加密传输、AES256bit或以上强度的加密算法进行加密存储、敏感信息脱敏显示等。<br>
              3、我们对可能接触到您信息的员工也采取了严格管理，可监控他们的操作情况，对于数据访问、内外部传输使用、脱敏、解密等重要操作建立了审批机制，并与上述员工签署保密协议等。与此同时，我们还定期对员工进行信息安全培训，要求员工在日常工作中形成良好操作习惯，提升数据保护意识。<br>
              4、尽管有前述的安全措施，但同时也请您理解在网络上不存在“完善的安全措施”。我们会按现有的技术提供相应的安全措施来保护您的信息，提供合理的安全保障，我们将尽力做到使您的信息不被泄露、损毁或丢失。<br>
              5、您的账户均有安全保护功能，请妥善保管您用于登录龙猫游平台的设备以及您的账户名及密码信息，切勿将设备提供他人用于登录龙猫游平台或将密码告知他人，如果您发现自己的个人信息泄露，特别是您的账户名和密码发生泄露，请您立即与我们的客服联系，以便我们采取相应的措施。<br>
              6、请您及时保存或备份您的文字、图片等其他信息，您需理解并接受，您接入我们的服务所用的系统和通讯网络，有可能因我们可控范围外的因素而出现问题。<br>
              7、在使用龙猫游平台服务进行网上交易时，请您妥善保护自己的个人信息（包括但不限于出行人姓名、联络方式或联系地址），仅在必要的情形下向他人提供。请使用复杂密码，协助我们保证您的账户安全。我们将尽力保障您发送给我们的任何信息的安全性。为防止他人未经授权使用您的密码或使用您的计算机、移动设备或SIM卡，如您发现自己的个人信息尤其是您的账户或密码发生泄露，请您立即联络龙猫游平台客服，以便我们核实后根据您的申请采取相应措施。<br>
              8、在不幸发生个人信息安全事件后，我们将按照法律法规的要求向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。事件相关情况我们将以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，上报个人信息安全事件的处置情况。
              <div class="text-bold text-gap">六、我们如何保护未成年人的个人信息</div>
              1、龙猫游非常重视对未成年人个人信息的保护。若您是18周岁以下的未成年人，在使用我们的服务前，应事先取得您法定监护人的同意。我们根据《中华人民共和国未成年人保护法》等国家相关法律法规的要求对未成年人的个人信息及隐私进行保护。<br>
              2、龙猫游不会主动直接向未成年人收集其个人信息。对于经监护人同意而收集未成年人个人信息的情况，我们仅在法律法规允许、监护人同意或保护未成年人所必要的情况下使用、共享、转移或披露此类信息。<br>
              3、<label class="text-bold">对于不满14周岁的儿童个人信息，我们还会遵循正当必要、知情同意、目的明确、安全保障、依法利用的原则，按照《儿童个人信息网络保护规定》等法律法规的要求进行收集、存储、使用、转移、披露等处理儿童个人信息。</label>当您作为监护人为被监护的儿童选择使用龙猫游平台相关旅行服务时，我们可能需要向您收集被监护的儿童个人信息，用于向您履行相关服务之必要。如果您不提供前述信息，您将无法享受我们提供的相关服务。此外，您在使用评价功能时可能会主动向我们提供儿童个人信息，请您明确知悉并谨慎选择。您作为监护人应当正确履行监护职责，保护儿童个人信息安全。<br>
              4、如您对儿童个人信息相关事宜有任何意见、建议或投诉，请联系我们，具体联系方式详见本政策“九、如何联系我们”。
              <div class="text-bold text-gap">七、您如何行使您的个人信息权利</div>
              您对您的个人信息享有以下权利：
              <div class="text-bold">（一）个人信息的删除</div>
              在下列情形中，您可以通过本政策第九条的联系方式与我们联系，向我们提出删除个人信息的请求，我们将在十五个工作日内回复您的请求：
              <br>
              （1）如果我们处理个人信息的行为违反法律法规；<br>
              （2）如果我们收集、使用您的个人信息，却未征得您的明确同意；<br>
              （3）如果我们处理个人信息的行为严重违反了与您的约定；<br>
              （4）如果您不再使用我们的产品或服务，或您主动注销了账户；<br>
              （5）如果我们永久不再为您提供产品或服务。<br>
              当您或我们协助您删除相关信息后，因为适用的法律要求或安全技术原因，我们可能无法立即从备份系统中删除相应的信息，我们将安全地存储您的个人信息并将其与任何进一步处理隔离，直至备份更新时可以清除这些信息或实现匿名。
              <div class="text-bold">（二）改变您授权同意的范围或撤回授权</div>
              您可以通过删除您的个人信息、关闭设备功能等方式改变您授权我们继续收集个人信息的范围或撤回您的授权。您也可以通过注销账户的方式，撤回我们继续收集您个人信息的全部授权。但请注意，每个业务功能需要一些基本的个人信息才能得以完成（见本政策“一、我们如何收集和使用您的个人信息”），当您撤回授权后，我们无法继续为您提供所对应的服务。同时，基于部分产品的特殊性和相关法律法规的要求，如果您使用的服务尚未结束（例如，您出行类产品/服务过程尚未结束，或金融类产品尚有欠款未结清），在服务结束之前您有可能无法撤回您的授权。
              <br>
              对于我们持续使用您的个人信息的数据处理行为，当您执行上述操作后，我们将不再处理相应的个人信息，但您的上述操作不会影响此前基于您的授权已经开展的个人信息处理。<br>
              <div class="text-bold">（三）获取个人信息副本</div>
              如您需要您的个人信息的副本，您可以通过本政策第九条的联系方式与我们联系，在核实您的身份后，我们将向您提供您在我们的服务中的个人信息副本（包括基本资料、身份信息），但法律法规另有规定的或本政策另有约定的除外。
              <div class="text-bold">（四）限制自动化决策</div>
              如您在使用我们提供的搜索服务时，需要查看不针对您个人特征的搜索结果，您可以在搜索结果页面选择其他的客观排序/筛选方式进行设置。<br>
              此外，在某些业务功能中，经向您告知并取得同意后，我们可能仅依据信息系统、算法在内的非人工自动决策机制做出决定。如果您认为这些决定显著影响您的合法权益，您有权通过本政策第九条的联系方式提出您的诉求，我们也将在十五个工作日内回复您的请求。
              <div class="text-bold">（五）个人信息的转移</div>
              如您需要将您的个人信息转移至指定的个人信息处理者，您可以通过本政策第九条的联系方式与我们联系，在核实您的身份后，经审核符合国家网信部门规定条件的，我们将向您提供个人信息转移的途径，但法律法规另有规定的或本政策另有约定的除外。<br>
              我们也将采取必要的信息管理措施与技术手段，确保转移过程的安全性，防止您的个人信息发生泄露、损毁、丢失、篡改等后果。
              <div class="text-bold">（六）响应您的请求</div>
              如果您无法通过上述方式访问、更正、补充或删除您的个人信息，或您需要访问、更正、补充或删除您在使用我们产品/服务时所产生的其他个人信息，或您需要获取您的个人信息副本或者转移您的个人信息，或您认为我们存在任何违反法律法规或与您关于个人信息的收集或使用的约定，您均可以通过本政策第九条的联系方式与我们联系。<br>
              为了保障安全，我们可能需要您提供书面请求，或提供您的身份证明文件，我们将在收到您反馈并验证您的身份后的十五个工作日内答复您的请求。对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情收取一定成本费用。对于无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际（例如，涉及备份服务器上存放的信息）的请求，我们可能会予以拒绝。<br>
              在以下情形中，按照法律法规要求，我们将无法响应您的请求：<br>
              （1）与龙猫游履行法律法规规定的义务相关的；<br>
              （2）与国家安全、国防安全有关的；<br>
              （3）与公共安全、公共卫生、重大公共利益有关的；<br>
              （4）与犯罪侦查、起诉和审判和执行判决等有关的；<br>
              （5）有充分证据表明您存在主观恶意或滥用权利的；<br>
              （6）出于维护您或其他个人的生命、财产等重大合法权益但又很难得到您本人同意的；<br>
              （7）响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的；<br>
              （8）涉及商业秘密的。
              <div class="text-bold text-gap">八、本政策的修订和通知</div>
              我们会在必要时修改个人信息保护政策，请您理解，我们可能会适时修订本政策，我们将标注本政策最近更新的日期，并经公示后生效。未经您明确同意，我们不会削减您按照本政策所应享有的权利。对于重大变更，我们还会提供更为显著的通知（包括对于某些服务，我们会通过电子邮件发送通知，说明个人信息保护政策的具体变更内容）。请您经常回访本政策，以阅读最新版本。<br>
              本政策所指的重大变更包括但不限于：<br>
              1、我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；<br>
              2、我们在所有权结构、组织架构等方面发生重大变化。如业务调整、破产并购等引起的所有者变更等；<br>
              3、个人信息共享、转移或公开披露的主要对象发生变化；<br>
              4、您参与个人信息处理方面的权利及其行使方式发生重大变化；<br>
              5、我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化时；<br>
              6、个人信息安全影响评估报告表明存在高风险时。<br>
              
              <div class="text-bold text-gap">九、如何联系我们</div>
              1、如您有任何与本政策相关的问题、意见或建议，您可以通过发送邮件至我们的客服邮箱<a class="text-link" href='mailto:op-4@cnbooking.net'>op-4@cnbooking.net</a>，或拨打我们的客服电话（<a class="text-link" href='tel:010-56304887'>010-56304887</a>）等多种方式与我们联系。<br>
              2、一般情况下，我们将在十五个工作日内回复。如果您对我们的回复不满意，特别是我们的个人信息处理行为损害了您的合法权益，您还可以向网信办、消费者保护协会等监管部门进行投诉，投诉方式如下：<br>
              （1）国家网信办举报中心：<label class="text-link" @click="routerWeb('https://www.12377.cn/')">www.12377.cn</label><br>
              （2）消费者投诉举报电话：<a class="text-link" href='tel:12315'>12315</a><br>
              或者您还可以通过向深圳市罗湖区人民法院提起诉讼以解决争议。
            </div>

           
            


        </div>
        
        <div class="text-bold"></div>
        <label class="text-bold"></label>
        <label class="text-link"></label>


    </div>
</template>

<script>
export default {
  name:'Privacy',
  data (){

  },
  methods:{
    routerWeb(url){
      console.log(111)
      console.log(url)
      window.location.href = url
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/usr/docs/privacy.vue